import { Component, Inject, Vue, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import Template from './template.vue';
import RestrictedMixin from '@/mixins/RestrictedMixin';
// import ListadosMixin from '@/mixins/ListadosMixin';
import { Validator } from 'vee-validate';
import AuthMixin from '@/mixins/AuthMixin';

const namespace: string = 'rolModule';

@Component({
  mixins: [Template, AuthMixin, RestrictedMixin],
  props: ['rol', 'agregando'],
})
export default class RolForma extends Vue {
  @Inject('$validator') public $validator!: Validator;
  // tslint:disable-next-line: ban-types
  @Action('addRol', { namespace }) private addRol!: Function;
  // tslint:disable-next-line: ban-types
  @Action('updateRol', { namespace }) private updateRol!: Function;
  // tslint:disable-next-line: ban-types
  @Action('deleteRol', { namespace }) private deleteRol!: Function;

  private editable: boolean = true;

  private async validate() {
    const validator = await this.$validator.validateAll();
    if (validator) {
      if (!this.$props.rol.created_at) {
        this.$props.rol.created_at = new Date().toISOString();
      }
      this.$props.rol.updated_at = new Date().toISOString();
      if (this.$props.agregando) {
        this.addRol(this.$props.rol);
      } else {
        this.updateRol(this.$props.rol);
      }
      this.$emit('cerrar', true);
    }
  }

}
